import { CalendarSettingsViewModel } from "../calendar-settings/api/calendar-settings"
import { CalendarSettingsId } from "../calendar-settings/api/calendar-settings-id"
import { useGetCalendarSettingsQuery } from "../calendar-settings/api/index"

type QueryOptions = {
  skip?: boolean
  refetchOnMountOrArgChange?: boolean
}

export const useCalendarSettingsById = (
  calendarSettingsId?: CalendarSettingsId,
  queryOptions?: QueryOptions
): UseCalendarSettingsByIdResult => {
  const skipQuery = !calendarSettingsId || queryOptions?.skip

  const { data, currentData, isLoading, ...requestStatus } = useGetCalendarSettingsQuery(
    calendarSettingsId ? [calendarSettingsId] : [],
    { ...queryOptions, skip: Boolean(skipQuery) }
  )

  return {
    ...requestStatus,
    data,
    calendarSettings: data?.calendarSettingsById[calendarSettingsId || ""],
    isLoading,
  }
}

type UseCalendarSettingsByIdResult = ReturnType<typeof useGetCalendarSettingsQuery> & {
  calendarSettings?: CalendarSettingsViewModel
}
